import Vue from 'vue'

const apis = {
  QUERY_DEPARTMENT_INFO: {
    url: '/xdap-app/user/select/queryChildDept',
    method: 'get',
    disableSuccessMsg: true
  },
  QUERY_ALL_DEPARTMENT: {
    url: '/xdap-app/department/select/queryDeptList',
    method: 'get',
    disableSuccessMsg: true
  },
  // 获取顶级部门
  QUERY_TOP_DEPARTMENT: {
    url: '/xdap-app/department/select/queryTopDeptList',
    method: 'get',
    disableSuccessMsg: true
  },
  // 获取子部门
  QUERY_CHILD_DEPARTMENT: {
    url: '/xdap-app/department/select/querySecondaryDeptList',
    method: 'get',
    disableSuccessMsg: true
  }
}

const loadDepartmentData = (deptId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_DEPARTMENT_INFO,
      params: {
        deptId: deptId || ''
      }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve({
              data: resp.data,
              total: resp.total
            })
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const queryAllDepartment = (keyWord) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_ALL_DEPARTMENT,
      params: {
        keyword: keyWord
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
// 查询顶级部门
const queryTopDepartment = () => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_TOP_DEPARTMENT
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}
// 查询子部门
const queryChildDepartment = (parentId) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.QUERY_CHILD_DEPARTMENT,
      params: {
        parentId
      }
    }
    Vue.prototype.$request(request).asyncThen((resp) => {
      if (resp.code === 'ok') {
        resolve({
          data: resp.data
        })
      }
    })
  })
}

export default {
  editorConfigType: 'DEPT_SELECT_DATA_SOURCE',
  componentName: 'FormConfigDeptSelectDataSource',
  configProperty: 'selectedDataSourceList',
  extras: {
    departmentConfig: {
      nodekey: 'id',
      props: {
        label: 'name',
        children: 'children',
        isLeaf: 'leafNodeFlag'
      },
      loadDepartmentData: loadDepartmentData
    },
    queryAllDepartmentData: queryAllDepartment,
    queryTopDepartmentData: queryTopDepartment,
    queryChildDepartmentData: queryChildDepartment
  }
}
